import React, { Component } from "react";
import { CallAPI, GetCookieFunction, parseIntFromStr } from '../../utils/util';
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();
        return <Component {...props} router={{ location, navigate, params, searchParams }} />;
    }
    return ComponentWithRouterProp;
}

class Allergies extends Component {
    constructor(props) {
        super(props);
        this.patient_id = parseIntFromStr(this.props.router.params.patientId);
        this.user_type = (GetCookieFunction("User")?.type === "doctor") ? "doctor" : "nurse";
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";
        this.state = { rows: [], patientID: this.patient_id };
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.patient_id}/allergies`, 'GET', (res) => {
            this.setState({ rows: res.length > 0 ? res : [] });
        });
    }

    onAddRow = () => {
        this.setState({ rows: [...this.state.rows, { id: 0, name: "", effect: "", delete: false }] });
    };

    onDeleteRow = (index) => {
        const rows = this.state.rows.map((row, i) =>
            i === index ? { ...row, delete: true } : row
        );
        this.setState({ rows });
    };

    onFieldChange = (index, field, value) => {
        const rows = this.state.rows.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        this.setState({ rows });
    };

    onSave = () => {
        if (this.state.rows.length === 0) {
            if (this.funnel) this.props.router.navigate(`/patients/${this.patient_id}/medications${this.funnel}`);
            return;
        }
        CallAPI(this.state, `patients/${this.patient_id}/allergies`, 'PUT', () => {
            if (this.funnel) {
                this.props.router.navigate(`/patients/${this.patient_id}/medications${this.funnel}`);
            } else {
                CallAPI({}, `patients/${this.patient_id}/allergies`, 'GET', (res) => {
                    this.setState({
                        rows: res.length > 0 ? res : [],
                        modalVariant: "success",
                        modalMessage: "Allergies saved successfully."
                    });
                });
            }
        }, () => {
            this.setState({ modalVariant: "danger", modalMessage: "Could not save allergies." });
        });
    };

    render = () => {
        const visibleRows = this.state.rows.filter(r => !r.delete);

        return (
            <div>
                <PatientNav patientId={this.patient_id} />

                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.patient_id} currentStep={5} />}
                    <div className="ci-header">
                        <h2>Allergies</h2>
                        <p>Record and manage patient allergy information</p>
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    <div className="editable-table-wrap">
                        {/* Header */}
                        <div className="editable-table-header">
                            <div className="editable-col-main">Allergy / Source</div>
                            <div className="editable-col-main">Symptoms / Effect</div>
                            <div className="editable-col-action"></div>
                        </div>

                        {/* Rows */}
                        {visibleRows.length === 0 ? (
                            <div className="editable-empty">No allergies on file. Click "Add Row" to add one.</div>
                        ) : (
                            visibleRows.map((row, i) => {
                                const realIndex = this.state.rows.indexOf(row);
                                return (
                                    <div key={i} className="editable-table-row">
                                        <div className="editable-col-main">
                                            <input
                                                type="text"
                                                placeholder="e.g. Penicillin"
                                                value={row.name}
                                                onChange={(e) => this.onFieldChange(realIndex, 'name', e.target.value)}
                                            />
                                        </div>
                                        <div className="editable-col-main">
                                            <input
                                                type="text"
                                                placeholder="e.g. Anaphylaxis, rash"
                                                value={row.effect}
                                                onChange={(e) => this.onFieldChange(realIndex, 'effect', e.target.value)}
                                            />
                                        </div>
                                        <div className="editable-col-action">
                                            <button
                                                type="button"
                                                className="editable-delete-btn"
                                                onClick={() => this.onDeleteRow(realIndex)}
                                                aria-label="Delete row"
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>

                    <div className="editable-actions">
                        <button type="button" className="homeButton" onClick={this.onAddRow}>
                            + Add Row
                        </button>
                        <button type="button" className="logSubmit" onClick={this.onSave}
                            style={{ width: 'auto', marginTop: 0 }}>
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };
}

export default withRouter(Allergies);
